import { render, staticRenderFns } from "./TransactionsRenewal.vue?vue&type=template&id=d470dc06&scoped=true"
import script from "./TransactionsRenewal.vue?vue&type=script&lang=js"
export * from "./TransactionsRenewal.vue?vue&type=script&lang=js"
import style0 from "./TransactionsRenewal.vue?vue&type=style&index=0&id=d470dc06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d470dc06",
  null
  
)

export default component.exports